import {
  EntityBuilder,
  globalTweens,
  SPRITE_COMPONENT,
  TRANSFORM_COMPONENT,
  SpriteComponent,
  TransformComponent,
} from 'agent-gamedev';
import type { EntityId, IWorld } from 'agent-gamedev';
import {
  ASSETS,
  GAME_HEIGHT,
  GAME_WIDTH,
  TILE_SIZE,
  Z_FLOOR,
} from '../config';
import { getThemeShadowStyle, type ShadowKind } from '../theme/GameTheme';

export type { ShadowKind } from '../theme/GameTheme';

const W = GAME_WIDTH;
const H = GAME_HEIGHT;

export interface ShadowOptions {
  kind?: ShadowKind;
  zIndex?: number;
}

export function createGroundShadow(
  world: IWorld,
  x: number,
  y: number,
  trackEntity: (eid: EntityId) => void,
  options: ShadowOptions = {},
): EntityId {
  const kind = options.kind ?? 'block';
  const style = getThemeShadowStyle(kind);
  const eid = EntityBuilder.create(world, W, H)
    .withTransform({ x: x + style.ox, y: y + style.oy })
    .withSprite({
      textureId: ASSETS.SHADOW_SOFT,
      width: TILE_SIZE * style.width,
      height: TILE_SIZE * style.height,
      zIndex: options.zIndex ?? Z_FLOOR + 1,
    })
    .build();
  trackEntity(eid);
  const sprite = world.getComponent<SpriteComponent>(eid, SPRITE_COMPONENT);
  if (sprite) sprite.alpha = style.alpha;
  return eid;
}

export function moveGroundShadowTo(
  world: IWorld,
  shadowEntity: EntityId | undefined,
  x: number,
  y: number,
  kind: ShadowKind,
  duration = 0,
): void {
  if (shadowEntity === undefined) return;
  const transform = world.getComponent<TransformComponent>(shadowEntity, TRANSFORM_COMPONENT);
  if (!transform) return;
  const style = getThemeShadowStyle(kind);
  const target = { x: x + style.ox, y: y + style.oy };
  globalTweens.killTweensOf(transform);
  if (duration > 0) {
    globalTweens.to(transform, target, { duration });
  } else {
    transform.x = target.x;
    transform.y = target.y;
  }
}
